import React from 'react';
import PropTypes from 'prop-types';
import './printComponent.scss';
import { Divider } from '@mui/material';
import moment from 'moment';

// eslint-disable-next-line react/display-name
const PrintComponentOrderList = React.forwardRef(({ orders }, ref) => {


    console.log(orders)

    if (!orders || !Array.isArray(orders) || orders.length === 0) {
        return (
            <div ref={ref} className="print-container">
                <p>No hay órdenes seleccionadas para imprimir.</p>
            </div>
        );
    }

    return (
        <div className="print-container" id="content-to-print" ref={ref}>
            {orders.map((order, i) => {
                if (order.status === 'cancelada') return null;

                return (
                    <div key={`${order.id}_${i}`} className="print-entry">
                        <div className="print-entry-header">
                            <div className="print-header-info">
                                <span style={{ fontSize: 22 }} >
                                    <label className="print-label">Proveedor:</label> {order?.supplier?.name || 'Sin proveedor'}
                                </span>
                                <span style={{ fontSize: 22 }} >
                                    <label className="print-label">Código:</label> {order.code}
                                </span>
                            </div>

                        </div>
                        <div className="print-entry-header">
                            <div className="print-header-info">
                                <span style={{ fontSize: 16 }} >
                                    <label className="print-label">Fecha de entrega: </label>
                                    {order.deliveryDate
                                        ? moment(order.deliveryDate).format('DD-MM-YYYY')
                                        : moment(order.scheduleDate).format('DD-MM-YYYY')}
                                </span>

                            </div>

                        </div>

                        <div className="print-entry-body">
                            <table className="print-table">
                                <thead>
                                    <tr>
                                        <th className="print-column">Producto</th>
                                        <th className="print-column">Medida</th>
                                        <th className="print-column">Cantidad</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {order.products?.map((product) => (
                                        <tr key={product.id}>
                                            <td className="print-column">{product.name}</td>
                                            <td className="print-column">{product.measurementUnit}</td>
                                            <td className="print-column">
                                                {product.deliveredQuantity ??
                                                    product.confirmedQuantity ??
                                                    product.requestedQuantity}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                        <Divider
                            sx={{
                                borderBottomWidth: 0,
                                borderTop: '1px dashed',
                                borderColor: 'rgb(0, 0, 0)',
                                my: 2,
                            }}
                        />
                    </div>
                );
            })}
        </div>
    );
});

PrintComponentOrderList.propTypes = {
    orders: PropTypes.array.isRequired,
};

export default PrintComponentOrderList;
